/* tslint:disable */
import {
  QualityMeasureValue,
  QualityMeasure,
  StockMove
} from '../index';

declare var Object: any;
export interface MoveQualityControlInterface {
  "id"?: number;
  "move_id"?: number;
  "quality_measure_id"?: number;
  "quality_value_id"?: number;
  "is_custom"?: boolean;
  "text_value"?: string;
  qualityValueId?: QualityMeasureValue;
  qualityMeasureId?: QualityMeasure;
  moveId?: StockMove;
}

export class MoveQualityControl implements MoveQualityControlInterface {
  "id": number;
  "move_id": number;
  "quality_measure_id": number;
  "quality_value_id": number;
  "is_custom": boolean;
  "text_value": string;
  qualityValueId: QualityMeasureValue;
  qualityMeasureId: QualityMeasure;
  moveId: StockMove;
  constructor(data?: MoveQualityControlInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MoveQualityControl`.
   */
  public static getModelName() {
    return "MoveQualityControl";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MoveQualityControl for dynamic purposes.
  **/
  public static factory(data: MoveQualityControlInterface): MoveQualityControl{
    return new MoveQualityControl(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MoveQualityControl',
      plural: 'MoveQualityControls',
      path: 'MoveQualityControls',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "move_id": {
          name: 'move_id',
          type: 'number'
        },
        "quality_measure_id": {
          name: 'quality_measure_id',
          type: 'number'
        },
        "quality_value_id": {
          name: 'quality_value_id',
          type: 'number'
        },
        "is_custom": {
          name: 'is_custom',
          type: 'boolean'
        },
        "text_value": {
          name: 'text_value',
          type: 'string'
        },
      },
      relations: {
        qualityValueId: {
          name: 'qualityValueId',
          type: 'QualityMeasureValue',
          model: 'QualityMeasureValue',
          relationType: 'belongsTo',
                  keyFrom: 'quality_value_id',
          keyTo: 'id'
        },
        qualityMeasureId: {
          name: 'qualityMeasureId',
          type: 'QualityMeasure',
          model: 'QualityMeasure',
          relationType: 'belongsTo',
                  keyFrom: 'quality_measure_id',
          keyTo: 'id'
        },
        moveId: {
          name: 'moveId',
          type: 'StockMove',
          model: 'StockMove',
          relationType: 'belongsTo',
                  keyFrom: 'move_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/MoveQualityControl.ts